import React, { useImperativeHandle, useState, useRef, useEffect, useContext } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { EmergenzeApi } from "../../data";
import { apiConfiguration } from "../../apiConfig";
import TenantContext from "../../contexts/tenantContext";
import notify from "devextreme/ui/notify";
import { showError } from "../../utils/errorHandling";
import { LoadPanel } from "devextreme-react";


type Props = {
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type EmergenzaCreatePopupHandle = {
  //edit: (emergenzaId: string, title?: string) => void,
  new: () => void
}

type state = {
  emergenzaId?: string,
  visible: boolean
}

const EmergenzaCreatePopup: React.ForwardRefRenderFunction<EmergenzaCreatePopupHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [state, setState] = useState<state>({ emergenzaId: undefined, visible: false });
  const [popupTitle, setPopupTitle] = useState<string>("Nuova emergenza");
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const [formData, setFormData] = useState<any>();
  const formRef = useRef<FormRef>(null);

  function hide() {
    setState({ emergenzaId: undefined, visible: false });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    var validate = formRef.current?.instance().validate();

    if (validate?.isValid) {
      const api = new EmergenzeApi(apiConfiguration);

      var data = formRef.current?.instance().option("formData");

      setLoadPanelVisible(true);

      try {
        if (state.emergenzaId) {
          await api.updateEmergenza({
            tenantId: currentTenant.Id,
            emergenzaId: state.emergenzaId,
            emergenzaUpdateDTO: data
          });

          props.onDataChanged?.();
        }
        else {
          await api.insertEmergenza({
            tenantId: currentTenant.Id,
            emergenzaCreateDTO: data
          });

          props.onDataChanged?.();
        }

        hide();

        return true;
      }
      catch (e) {
        showError(e);
        return false;
      }
      finally {
        setLoadPanelVisible(false);
      }

    }
    else {
      notify("Correggere gli errori di validazione", "error", 2000);
      return false;
    }



    // api.insertEmergenza({
    //   tenantId: currentTenant.Id,
    //   emergenzaCreateDTO: 
    // })
    // if (await operatoreEditPanelRef.current?.save()) {
    //    props.onDataChanged?.();
    //   hide();
    // }
  }

  useImperativeHandle(ref, () => ({
    // edit(operatoreId, title) {
    //   setState({
    //     operatoreId: operatoreId,
    //     visible: true
    //   });
    //   if (title)
    //     setPopupTitle(title);
    // },

    new() {
      setFormData({
        dataInizio: new Date()
      });

      setState({
        emergenzaId: undefined,
        visible: true
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
        <Popup
          visible={true}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          fullScreen={fullscreen}
          showTitle={true}
          onHidden={hide}
          title={popupTitle}
          container=".dx-viewport"
          width={fullscreen ? '100%' : 600}
          height={fullscreen ? '100%' : 'auto'}
        >
          <Position
            at="center"
            my="center"
            of=""
            collision="fit"
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="top"
            location="after"
            //visible={!(isXSmall || isSmall)}  
            options={{
              icon: 'fullscreen',
              onClick: () => setFullscreen(!fullscreen),
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Salva',
              type: 'default',
              stylingMode: 'contained',
              onClick: SaveAndClose
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Annulla',
              type: 'normal',
              stylingMode: 'contained',
              onClick: hide
            }}
          />

          <Form id="form"
            ref={formRef}
            colCount={2}
            formData={formData}
            labelMode='floating' >

            <Item dataField="nome" isRequired={true} />
            <Item dataField="dataInizio" isRequired={true} editorType="dxDateBox" editorOptions={{ type: "datetime" }} />
            <Item dataField="note" editorType="dxTextArea" colSpan={2} />

          </Form>

           <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
        </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaCreatePopup);
